// @core/api/endpoints/platform/get_platform.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get platform by ID
 * Retrieves a platform by its unique identifier. Returns the full platform details including settings, status, and metadata.
 */
export async function GetPlatform(
  platform_id: string,
  options?: RequestOptions
): Promise<PlatformResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<PlatformResponse>(requestPath, { ...requestOptions });
}
